// extracted by mini-css-extract-plugin
module.exports = {"circular":"loader_circular__WwFkP","spin":"loader_spin__BnD38"};